import React from 'react';

const LatestIssues = ({ latestPassageSubtopics }) => {
  return (
    <div className="latest-issues">
      <div className="trending-interests-header">
        <h3>What others are discussing</h3>
      </div>
      <ul>
        {latestPassageSubtopics.map((item, index) => (
          <li key={index}>
            <span className="latest-issue-text">{item}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default LatestIssues;
